import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'writ-action',
    templateUrl:'WritAction.html'
})
export class WritActionComponent extends BaseActionComponent{

  public writs;
  public writ;
  public jobs;
  public job;
  public selectedWritId;
  public linkForm: FormGroup;
  public onClickAction=false;
  public text=''
  public action
  public selectedMission;
  public selectedMissionAction;
  public level=1;

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
    this.linkForm = this.fb.group({
      give: false,
      associate:false,
      test:false
    });
  }
  public processData(action){
    let linkParam = this.linkForm['_value'];
    if (linkParam.give){
      action.param.kind='give'
    }
    else if (linkParam.associate){
      this.action.param.kind='associate'
      if (linkParam.test){
        action.param.test=true
      }
    }
    else if (linkParam.test){
      action.param.kind='test'
    }
    action.param.writ=this.writ.group
    action.param.job=this.job.id;
  }
  public chooseJob(job){
    this.jobs.forEach(j=>{
      if (job.id==j.id){
        j.selected=true
      }
      else{
        j.selected=false;
      }
    })
    this.action.param.job=job.id
    this.job=job
  }
  public chooseMissionAction(val) {
    this.selectedWritId = Number(val)//(document.getElementById('boardWrit') as HTMLSelectElement).value;
    this.writ=this.writs[this.selectedWritId]
    this.action.param = {
      writ: this.writ.group,
      job: 0 // Indica que é do Trello
    };
    this.jobs=this.writ.jobs
  }  
  public childrenReloadData(){
    if (this.level==1){
      this.action = this._appData.action;
    }
    else{
      this.action = this._appData.secondAction;
    }
    if (!this.action.param){
      this.action.param={
        writ:0,job:0
      }
    }
    else{
      if (this.action.param.kind=='give'){
        this.linkForm = this.fb.group({
          give: true,
          associate:false,
          test:false
        });
      }
      else if (this.action.param.kind=='associate'){
        if (this.action.param.test){
          this.linkForm = this.fb.group({
            give: false,
            associate:true,
            test:true
          }); 
        }
        else{
          this.linkForm = this.fb.group({
            give: false,
            associate:true,
            test:false
          });
  
        }
      }
      else if (this.action.param.kind=='test'){
        this.linkForm = this.fb.group({
          give: false,
          associate:false,
          test:true
        });
      }
    }
    this.writs=[]
    this.jobs=[]
    if (this.action.param.writ){
      this.selectedWritId=this.action.param.writ;
    }
    let variable=this._appData.company ? this._appData.company.dbId : null;
    let ref =this._companyService.getWrits(this._appData.company.dbId)

    ref.get().then(its=>{
      let id=0
      its.forEach(it=>{
        let writ=it.data();
        this.writs.push(writ)
        if (this.writs.length==1){
          this.selectedWritId=id;
          this.writ=writ
          this.jobs=[]
          writ.jobs.forEach(j=>{
            j.selected=false;
            this.jobs.push(j)
          })

        }
        if (this.action.param.writ && this.action.param.writ==writ.group){
          this.jobs=[]
          writ.jobs.forEach(j=>{
            if (this.action.param.job==j.id){
              j.selected=true;
              this.job=j;

            }
            else{
              j.selected=false;
            }
            this.jobs.push(j)
          })
          this.selectedWritId=id;
        }
        id++

      })
    })
  }
    public ngOnInit(): any {


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/WritAction.ts